import type { Variables } from '~/contracts/ProductRepositoryContract'

export function useSegmentedUpsell() {
  const cartStore = useCartStore()
  const productStore = useProductStore()

  const storyblokStore = useStoryblokStore()
  const { state: storyblok } = storeToRefs(storyblokStore)

  const { getSegmentVariables, activeSegmentId } = useSegment()

  const currentSegmentId = activeSegmentId.value || 'default'

  const activeUpsellStory = computed(() => {
    const story = storyblok.value.segmentedUpsellStories?.find(story => story.identifier === currentSegmentId)

    // Return early if a valid story is found
    if (story?.widgetId) {
      return story
    }

    // Otherwise, use the default story
    return storyblok.value.segmentedUpsellStories?.find(story => story.identifier === 'default')
  })

  const priceTotal = computed(() => cartStore.state.priceTotal)
  const widgetId = computed(() => activeUpsellStory.value?.widgetId)
  const segmentVariables = computed(() => widgetId.value ? getSegmentVariables(widgetId.value) : {})

  const upsellVariables = computed(() => {
    if (!segmentVariables)
      return {}

    return activeUpsellStory.value?.variables.reduce((acc, variable) => {
      const value = segmentVariables.value?.[variable] as string | undefined

      if (value)
        acc[variable] = value

      return acc
    }, {} as Variables)
  })

  const upsellDescription = useRichtext(computed(() => activeUpsellStory.value?.description))

  const { data: upsellProducts } = useAsyncData('upsellBasket', async () => {
    if (!widgetId.value)
      return []
    return (await productStore.fetchProductsForBasket({ widgetId: widgetId.value, variables: upsellVariables.value })).products
  }, {
    watch: [priceTotal, widgetId],
  })

  return {
    upsellDescription,
    upsellProducts,
  }
}
